<template>
    <div>
        <div> 
            <label class="typo__label text-primary" for="ajax">Buscar Estudiante:</label>
            <multiselect class="form-control input-group-sm" v-model.trim="modelo.idestudiante" id="id" label="nombre" track-by="id" placeholder="Ingrese el Nombre o documento (4 letras minimo)..." 
                open-direction="bottom" :options="datos" :multiple="false" 
                :searchable="true" :loading="isLoading" :internal-search="false" :clear-on-select="true" :close-on-select="true" 
                :options-limit="300" :limit="15" :limit-text="limitText" :max-height="600" :show-no-results="true" 
                :hide-selected="true" :show-labels="false" @search-change="asyncFind">

                <template slot="tag" slot-scope="{ option, remove }"><span class="custom__tag"><span>{{ parseLabel(option) }}</span><span class="custom__remove" @click="remove(option)">❌</span></span></template>
                <template slot="clear" slot-scope="props">
                <div class="multiselect__clear" v-if="modelo.idestudiante==null" @mousedown.prevent.stop="clearAll(props.search)"></div>
                </template>
                <span slot="noResult">Estudiante no encontrado</span>
            </multiselect>
        </div>
    </div>
</template>

<script>
import gql from 'graphql-tag'
// import {parseJsonError} from '@/components/Utils.js'
export default {
    props:{ 
        model:Object, 
        inscripcion:{type:Object,required:true},
        default:{type:Object,required:false,default:null},
        thiz: Object,
    },
    data () {
        return {
            isLoading: false,
            datos: [], 
            modelo: {
                idestudiante: null,
            }
        }
    },
    watch:{
        'modelo.idestudiante': function(){
            // window.console.log('modelo.idestudiante...',this.modelo.idestudiante)
            this.inscripcion.idestudiante=this.modelo.idestudiante; 
        },
        'default':function(a){
            if( a == null ) return;
            this.modelo.idestudiante = a;
        },
    },
    methods: {
        parseLabel( option ){
            if( option == null ) return "";
            var seg = option.seg_apellido;
            if( seg == null ) seg = "";
            return option.nombres + " "+option.pri_apellido+" "+seg;
        },
        parseLabel2( option ){
            if( option == null ) return "";
            var seg = option.seg_apellido;
            if( seg == null ) seg = "";
            return option.nombres + " "+option.pri_apellido+" "+seg+" -- Doc: "+option.num_doc;
        },
        limitText (count) {
            return `and ${count} other countries`
        },
        /*async asyncFind (query) {
            if( query.length <= 3 ) return;
            this.isLoading = true
            var vue = this;
            var isdocumento = /^\d+$/.test(+query);
            var sql = gql`query{ getPersonasByName(nombres:"${query}"){id,num_doc,nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,contacto } }`;
            if( isdocumento || query.includes('-') ) sql = gql`query{ getPersonasByDoc(num_doc:"${query}"){id,num_doc,nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,contacto } }`;
            await this.$apollo.query({
                query: sql,
            }).then((data) => {
                vue.datos = [];
                var datas = [];
                vue.isLoading = false;

                for (var propName in data.data) { 
                    if( propName == "getPersonasByName" || propName == "getPersonasByDoc" ){
                        data.data[propName].forEach( function(e){
                            e.nombre = vue.parseLabel2( e );
                            datas.push( e );
                        });
                    }
                }
                vue.datos = datas;
                if(datas.length == 0 ){
                    this.thiz.show_reg = true;
                }else{
                    this.thiz.show_reg = false;
                }
            }).catch((error) => {
                window.console.error(error)
                vue.isLoading = false;
                // this.thiz.show_reg = true;
                this.$notify( parseJsonError( error,'getPersonasByName' ) )
            })
        },*/
        async asyncFind (query) {
            if( query.length <= 3 ) return;
            this.isLoading = true;

            var sql = gql`query{ getPersonasSearchNameOrNumDoc(text:"${query}",cursor: 10000000, estado: true){id,num_doc,nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,contacto}}`;
            const res = await this.$apollo.query({query: sql}).then((data)=>data).catch(e=>e);
            this.isLoading = false;
            if(res && res.data){

                this.datos = [];
                let datas = res.data.getPersonasSearchNameOrNumDoc;
                this.isLoading = false;
                const vue = this;

                datas.forEach(x=> x.nombre = vue.parseLabel2( x )) 
                
                this.datos = datas;
                if(datas.length == 0 ) this.thiz.show_reg = true;
                else this.thiz.show_reg = false; 
            }
            // window.console.log('resss',res.data);
            
        },
        clearAll () {
            this.modelo.idestudiante = null;
        },
        setNew(nuevo){
            window.console.log('On New Reg:: ', nuevo);
            let e = JSON.parse(JSON.stringify(nuevo));
            e.nombre = this.parseLabel2( e );
            if(!this.datos) this.datos = [];
            this.datos.push(e);
            this.modelo.idestudiante = e;
        }
    },
    mounted(){
        
    }
}
</script>